import React from "react";
import { useFormContext } from "react-hook-form";
import { TextField } from "@material-ui/core";
import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";

const AdditionalNotesTextField = () => {
  const { register } = useFormContext<CreateDisbursementFormFields>();

  return (
    <TextField
      fullWidth
      name={"notes"}
      inputRef={register({
        required: false,
      })}
      multiline
      rowsMax="10"
      variant={"outlined"}
      placeholder={"(Optional)"}
    />
  );
};

export default AdditionalNotesTextField;
